import styled from 'styled-components/macro';
import { fontSize, lineHeight, media, space } from '../../../theme/tokens';
import { Inline, StaffCard, StaffSubHeader } from '../../common/elements/Staff';

export const CategoryCard = styled(StaffCard)`
  min-height: 8rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${space[3]};
`;

export const CategoryTitle = styled(StaffSubHeader)`
  flex: 1 1 auto;
  min-width: 0;
  max-width: 100%;
  padding: 0;
  font-size: ${fontSize.xl};
  line-height: ${lineHeight.tight};
  overflow-wrap: anywhere;

  ${media.md`
    width: 22rem;
  `}
`;

export const InlineJustified = styled(Inline)`
  justify-content: space-between;
  ${media.md`
    align-items: baseline;
  `}
`;

export * from '../../common/elements/Assessments';
export * from '../../common/elements/Form';
export * from '../../common/elements/Staff';
